import { InputText } from "primereact/inputtext";
import { useState } from "react";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { login } from "./api/routes";
import styles from "./Splash.module.css";
import * as client from "./client";
import { useToast } from "./context-providers/Toast";

type SplashProps = {
  onSuccessfulAuth: (clientId: string, user: client.User | undefined) => void;
};

export const Splash: React.FC<SplashProps> = ({ onSuccessfulAuth }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const makeAuthCall = () => {
    setLoading(true);
    login(email, password).then((result) => {
      setLoading(false);

      if (result.success) {
        onSuccessfulAuth(result.clientId, result.user);
      } else {
        toast.show({
          severity: "warn",
          summary: "Login Failed",
          detail: "Please enter a valid password.",
          life: 5000,
        });
      }
    });
  };

  return (
    <div className={styles.splashContainer}>
      <Card title="Welcome!" className={styles.splashCard}>
        <span>Email</span>
        <InputText
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className={styles.inputText}
          onKeyDown={(event) => {
            if (event.key === "Enter" && email && password) {
              makeAuthCall();
            }
          }}
        />
        <span>Password</span>
        <InputText
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className={styles.inputText}
          onKeyDown={(event) => {
            if (event.key === "Enter" && email && password) {
              makeAuthCall();
            }
          }}
        />
        <Button
          className={styles.submitButton}
          label="Submit"
          disabled={password === ""}
          onClick={makeAuthCall}
          loading={loading}
        />
      </Card>
    </div>
  );
};
